module.exports = __webpack_public_path__ + "img/101.241279bd.png";